export const accountMenu = {
  MY_ACCOUNT_CLICKED: 'accountMenu.myAccountClicked',
  CREATE_ACCOUNT_CLICKED: 'accountMenu.createAccountClicked',
  MY_BOOKINGS_CLICKED: 'accountMenu.myBookingsClicked',
  FAVORITES_CLICKED: 'accountMenu.favoritesClicked'
}
